import { render } from "./NavNotif.vue?vue&type=template&id=365f2427"
import script from "./NavNotif.vue?vue&type=script&lang=js"
export * from "./NavNotif.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__